import * as React from "react";
import { Header } from '../components/header';
import { userInfo, getDefaultUserInfo, ChangePassword } from "../api/dataTypes";
import { UserAccountInfo } from "../components/UserAccountInfo";
import * as accountApi from "../api/api-account";
import * as userApi from "../api/api-user";
import { PromiseHelper } from "../classes/promiseHelper";

interface State {
  userInfo: userInfo;
  message: string;
  passwordChangeMessage: string;
}

export interface Props {
  // match: { params: { washName: string } };
}

export class AccountPage extends React.Component<Props, State> {
  currentUserPromise:PromiseHelper<userInfo|null> = new PromiseHelper();

  constructor(props: Props) {
    super(props);
    this.state = {
      userInfo: getDefaultUserInfo(),
      message: "",
      passwordChangeMessage: ""
    };
  }

  componentDidMount() {
    this.getUserInfo();
    //accountApi.getCurrentUser();
  }

  componentWillUnmount(){
    this.currentUserPromise.clearPromise();
  }

  render() {
    return (
      <React.Fragment>
        <Header />
        <div>
          <div className="col-12 header-page-title">Account</div>
          <div className="component-standard">
            {//<div className="row component-standard">
            }
              <UserAccountInfo
                userInfo={this.state.userInfo}
                handleChange={this.onInputChange}
                handleSave={this.handleSave}
                message={this.state.message}
                changePassword={this.changePassword}
                passwordChangeMessage={this.state.passwordChangeMessage}
              />
            {//</div>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleFieldChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    var newState = {
      ...this.state.userInfo,
      [e.currentTarget.name]: e.currentTarget.value
    };
    this.setState({ userInfo: newState });
  }

  private onInputChange = (name: string, value: string | number) => {
    let newData = this.state.userInfo;
    newData[name] = value;
    this.setState({
      userInfo: newData
    });
  }

  handleSave = () => {
    userApi.editUserApi(this.state.userInfo)
    .then(result => {
      this.setState({ message: "Data Saved" });
    })
    .catch(e => {
      this.setState({ message: "Could Not Save Changes. " + e });
    });
  }

  getUserInfo = () => {
    this.currentUserPromise!.newPromise(accountApi.getCurrentUser(),
    res => {
      this.setState({userInfo:res});
    },
    error => {
      alert("error getting current user.")
    });
    // let email: string = accountApi.getUserName();
    // userApi.getUsersApi().then(result => {
    //   if (result && email !== "") {
    //     let currentUser: userInfo =
    //       result[result.findIndex(e => e.email === email)];
    //     if (currentUser !== null && currentUser.id !== "") {
    //       this.setState({
    //         userInfo: currentUser
    //       });
    //       return currentUser;
    //     } else {
    //       return null;
    //     }
    //   } else {
    //     return null;
    //   }
    // });
  }

  private changePassword = (changePassword: ChangePassword) => {
    accountApi.changePassword(changePassword).then(result => {
      if (result) {
        this.setState({
          passwordChangeMessage: "Password updated successfully"
        });
      } else {
        this.setState({
          passwordChangeMessage: "Error changing password, please retry"
        });
      }
    });
  }
}
